
import { empty as empty_1, filter, map as map_1, isEmpty, contains, tryHead, toArray, singleton, ofArray, choose } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { bind, unwrap, defaultArg, map } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { SavedTableFilter, SavedTableFilter_$reflection, SavedColumnFilter } from "../../Shared/User.js";
import { FSharpMap__TryFind } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Map.js";
import { Union } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { union_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { concat, join, isNullOrWhiteSpace } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { createObj, stringHash } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { ConfirmationDialog, Dialog } from "../../Components/Dialog.js";
import { Input } from "../../Components/Input.js";
import { TextButton } from "../../Components/Button.js";
import { empty, singleton as singleton_1, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { TableMsg$1 } from "./Types.js";
import Pencil from "../../../public/assets/icons/Pencil.svg";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { ReactPopover } from "../../Components/ReactPopover.js";

export function toSavedColumnFilters(columnDefinitionMap, columnFilters) {
    return choose((columnFilter) => map((columnDefinition) => {
        const matchValue = columnDefinition.Filter;
        switch (matchValue) {
            case "select":
            case "categorySelect":
            case "dateRange":
                return new SavedColumnFilter(columnFilter.id, ofArray(columnFilter.value));
            default:
                return new SavedColumnFilter(columnFilter.id, singleton(columnFilter.value));
        }
    }, FSharpMap__TryFind(columnDefinitionMap, columnFilter.id)), ofArray(columnFilters));
}

export function toColumnFilters(columnDefinitionMap, savedFilter) {
    return toArray(choose((savedColumnFilter) => map((columnDefinition) => {
        const matchValue = columnDefinition.Filter;
        switch (matchValue) {
            case "select":
            case "categorySelect":
            case "dateRange":
                return {
                    id: savedColumnFilter.ColumnId,
                    value: toArray(savedColumnFilter.Values),
                };
            default:
                return {
                    id: savedColumnFilter.ColumnId,
                    value: defaultArg(tryHead(savedColumnFilter.Values), ""),
                };
        }
    }, FSharpMap__TryFind(columnDefinitionMap, savedColumnFilter.ColumnId)), savedFilter.ColumnFilters));
}

class CustomFilterDialog extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SaveFilter", "RenameFilter", "DeleteFilter"];
    }
}

function CustomFilterDialog_$reflection() {
    return union_type("Widgets.Table.CustomFilters.CustomFilterDialog", [], CustomFilterDialog, () => [[], [["Item", SavedTableFilter_$reflection()]], [["Item", SavedTableFilter_$reflection()]]]);
}

function CustomFilterNameDialog(props) {
    const t = useTranslation()[0];
    const patternInput_1 = reactApi.useState(props.InitialName);
    const setFilterName = patternInput_1[1];
    const filterName = patternInput_1[0];
    const dependencies = [props.IsOpen];
    reactApi.useEffect(() => {
        setFilterName(props.InitialName);
    }, dependencies);
    const isNameValid = !isNullOrWhiteSpace(filterName) && !contains(filterName.trim(), props.ForbiddenNames, {
        Equals: (x, y) => (x === y),
        GetHashCode: (x) => (stringHash(x) | 0),
    });
    return createElement(Dialog, {
        Body: singleton(createElement(Input, {
            ComponentState: "enabled",
            Label: t("table.custom_filters.name_label"),
            OnChange: setFilterName,
            TestId: "custom-filter-name-input",
            Value: filterName,
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "custom-filter-name-dialog-cancel-button",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: isNameValid ? "enabled" : "disabled",
            Label: t("general.save"),
            OnClick: () => {
                props.OnSave(filterName.trim());
            },
            TestId: "custom-filter-name-dialog-save-button",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: props.Title,
    });
}

function CustomFilterSection(props) {
    let elems_7;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-2"])], (elems_7 = toList(delay(() => append(singleton_1(reactElement("div", {
        className: join(" ", ["text-sm", "font-bold"]),
        children: t("table.custom_filters.title"),
    })), delay(() => {
        let elems_5;
        return append(isEmpty(props.SavedFilters) ? singleton_1(reactElement("div", {
            className: join(" ", ["text-sm", "text-gray-500"]),
            children: t("table.custom_filters.no_saved_filters"),
        })) : singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "flex-col", "gap-1"])], (elems_5 = toList(delay(() => map_1((savedFilter) => {
            let elems_4, elems_1, elems, elems_3, elems_2;
            return reactElement("div", createObj(ofArray([["key", savedFilter.Name], ["className", join(" ", ["flex", "items-center", "gap-3", "justify-between"])], (elems_4 = [reactElement("button", {
                className: join(" ", ["grow", "text-left", "text-sm", "cursor-pointer", "hover:text-primary", "truncate", "outline-none"]),
                "data-test-id": concat("apply-custom-filter-", ...savedFilter.Name),
                onClick: (_arg) => {
                    props.Dispatch(new TableMsg$1(6, [toColumnFilters(props.ColumnDefinitionMap, savedFilter)]));
                    props.OnClose();
                },
                children: savedFilter.Name,
            }), reactElement("button", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "cursor-pointer", "outline-none"])], ["data-test-id", concat("rename-custom-filter-", ...savedFilter.Name)], ["onClick", (_arg_1) => {
                props.SetOpenDialog(new CustomFilterDialog(1, [savedFilter]));
                props.OnClose();
            }], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems = [Pencil()], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), reactElement("button", createObj(ofArray([["className", join(" ", ["flex", "items-center", "justify-center", "cursor-pointer", "outline-none"])], ["data-test-id", concat("delete-custom-filter-", ...savedFilter.Name)], ["onClick", (_arg_2) => {
                props.SetOpenDialog(new CustomFilterDialog(2, [savedFilter]));
                props.OnClose();
            }], (elems_3 = [reactElement("div", createObj(ofArray([["className", join(" ", ["h-4", "w-4"])], (elems_2 = [Delete_1()], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
        }, props.SavedFilters))), ["children", reactApi.Children.toArray(Array.from(elems_5))])])))), delay(() => {
            let elems_6, Label;
            return singleton_1(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-center"])], (elems_6 = [createElement(TextButton, (Label = t("table.custom_filters.save_current"), {
                ComponentState: (props.ColumnFilters.length === 0) ? "disabled" : "enabled",
                Label: Label,
                OnClick: () => {
                    props.SetOpenDialog(new CustomFilterDialog(0, []));
                    props.OnClose();
                },
                TestId: "save-custom-filter-button",
                Variant: "blueButton",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

export function TableFilterDropDown(props) {
    const patternInput = useTranslation();
    const t = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setOpenDialog = patternInput_1[1];
    const xs_2 = toList(delay(() => {
        let matchValue, savedFilter, Title_1, savedFilter_1, Title_2, arg_1;
        return append((matchValue = patternInput_1[0], (matchValue == null) ? (empty()) : ((matchValue.tag === 1) ? ((savedFilter = matchValue.fields[0], singleton_1(createElement(CustomFilterNameDialog, (Title_1 = t("table.custom_filters.rename_dialog_title"), {
            ForbiddenNames: filter((name) => (name !== savedFilter.Name), map_1((_arg_1) => _arg_1.Name, props.SavedFilters)),
            InitialName: savedFilter.Name,
            IsOpen: true,
            OnClose: () => {
                setOpenDialog(undefined);
            },
            OnSave: (newName) => {
                props.Dispatch(new TableMsg$1(12, [savedFilter.Name, newName]));
                setOpenDialog(undefined);
            },
            Title: Title_1,
        }))))) : ((matchValue.tag === 2) ? ((savedFilter_1 = matchValue.fields[0], singleton_1(createElement(ConfirmationDialog, (Title_2 = t("table.custom_filters.delete_dialog_title"), {
            Description: (arg_1 = {
                name: savedFilter_1.Name,
            }, patternInput[1].t("table.custom_filters.delete_dialog_description", arg_1)),
            IsOpen: true,
            OnClose: () => {
                setOpenDialog(undefined);
            },
            OnConfirm: () => {
                props.Dispatch(new TableMsg$1(13, [savedFilter_1.Name]));
                setOpenDialog(undefined);
            },
            Title: Title_2,
        }))))) : singleton_1(createElement(CustomFilterNameDialog, {
            ForbiddenNames: empty_1(),
            InitialName: "",
            IsOpen: true,
            OnClose: () => {
                setOpenDialog(undefined);
            },
            OnSave: (filterName) => {
                props.Dispatch(new TableMsg$1(11, [new SavedTableFilter(filterName, toSavedColumnFilters(props.ColumnDefinitionMap, props.ColumnFilters))]));
                setOpenDialog(undefined);
            },
            Title: t("table.custom_filters.save_dialog_title"),
        }))))), delay(() => {
            let ButtonLabel;
            return singleton_1(createElement(ReactPopover, (ButtonLabel = t("general.filter"), {
                Body: (onClose) => {
                    let elems;
                    return singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["p-4", "flex", "flex-col", "gap-3", "min-w-[280px]"])], (elems = toList(delay(() => append(props.CustomTableFilters ? singleton_1(createElement(CustomFilterSection, {
                        ColumnDefinitionMap: props.ColumnDefinitionMap,
                        ColumnFilters: props.ColumnFilters,
                        Dispatch: props.Dispatch,
                        OnClose: onClose,
                        SavedFilters: props.SavedFilters,
                        SetOpenDialog: setOpenDialog,
                    })) : empty(), delay(() => {
                        const matchValue_1 = props.FilterDropDown;
                        if (matchValue_1 == null) {
                            return empty();
                        }
                        else {
                            const filterDropDown = matchValue_1;
                            return append(props.CustomTableFilters ? singleton_1(reactElement("div", {
                                className: join(" ", ["border-t", "border-border"]),
                            })) : empty(), delay(() => singleton_1(filterDropDown.Content({
                                OnClose: onClose,
                                ResetColumnFilters: () => {
                                    props.Dispatch(new TableMsg$1(10, []));
                                },
                            }))));
                        }
                    })))), ["children", reactApi.Children.toArray(Array.from(elems))])]))));
                },
                ButtonBadge: unwrap(bind((_arg_5) => _arg_5.Badge, props.FilterDropDown)),
                ButtonLabel: ButtonLabel,
                ComponentState: "enabled",
                TestId: "table-filter-dropdown-button",
            })));
        }));
    }));
    return react.createElement(react.Fragment, {}, ...xs_2);
}

